import React, { useState, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './Dashboard.css';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const API_BASE_URL = 'http://localhost:8000/api'

  useEffect(() => {
    // Simulate API call
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          throw new Error('Authentication token not found');
        }

        const response = await fetch(`${API_BASE_URL}/dashboard/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });
        await new Promise(resolve => setTimeout(resolve, 2000));
        const data = await response.json();
        console.log("Dashboard data", data)
        setDashboardData(data);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const renderSkeleton = () => (
    <div className="dashboard-skeleton">
      <div className="stats-grid">
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className="stat-card">
            <Skeleton height={100} />
          </div>
        ))}
      </div>
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <Skeleton height={300} />
        </div>
        <div className="dashboard-card">
          <Skeleton height={300} />
        </div>
      </div>
      <div className="dashboard-card">
        <Skeleton height={200} />
      </div>
    </div>
  );

  const renderContent = () => (
    <div className="dashboard-content">
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Revenue</h3>
          <p className="stat-value">${dashboardData.total_revenue}</p>
          <p className="stat-label">This Month</p>
        </div>
        <div className="stat-card">
          <h3>Total Expenses</h3>
          <p className="stat-value">${dashboardData.total_expense}</p>
          <p className="stat-label">This Month</p>
        </div>
        <div className="stat-card">
          <h3>Monthly Budget</h3>
          <p className="stat-value">${dashboardData.monthlyBudget}</p>
          <p className="stat-label">Remaining: ${dashboardData.monthlyBudget - dashboardData.totalExpenses}</p>
        </div>
        <div className="stat-card">
          <h3>Total Savings</h3>
          <p className="stat-value">${dashboardData.total_savings}</p>
          <p className="stat-label">This Month</p>
        </div>
        
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Recent Transactions</h3>
          <div className="transactions-list">
            {dashboardData.recent_transactions.map(transaction => (
              <div key={transaction.id} className="transaction-item">
                <div className="transaction-info">
                  <p className="transaction-description">{transaction.description}</p>
                  <p className="transaction-date">{transaction.date}</p>
                </div>
                <p style={{backgroundColor: `${transaction.category_details.color}`, color: '#ffff'}} className="transaction-amount">${transaction.amount}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Transaction Categories</h3>
          <div className="categories-list">
            {dashboardData.first_5_categories.map(category => (
              <div key={category.name} className="category-item">
                <div className="category-info">
                  <div 
                    className="category-color" 
                    style={{ backgroundColor: category.color }}
                  />
                  <p className="category-name">{category.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="dashboard-card">
        <h3>Monthly Overview</h3>
        <div className="monthly-overview">
          {/* Add your chart component here */}
          <p className="placeholder-text">Chart will be displayed here</p>
        </div>
      </div>
    </div>
  );

  return (
    <Layout>
      <div className="dashboard">
        <h1 className="page-title">Dashboard</h1>
        {loading ? renderSkeleton() : renderContent()}
      </div>
    </Layout>
  );
};

export default Dashboard;
